<template>
    <section>
        <Transition>
            <ReportBugModalVue v-if="$store.state.modals.tools.reportBugModalStatus" />
        </Transition>
        <Transition>
            <SendMeetingRegarding v-if="$store.state.modals.sessions.sendMeetingRegardingModalStatus" />
        </Transition>
        <Transition>
            <PrepareMeetingInvitation v-if="$store.state.modals.sessions.prepareMeetingInvitationModalStatus" />
        </Transition>

        <Transition>
            <SessionAudioLinkModal v-if="$store.state.modals.sessions.audioVideoLinkModalStatus" />
        </Transition>

        <Transition>
            <ClientInvoiceBuyerModal v-if="$store.state.modals.settings.clientInvoiceBuyerModalStatus" />
        </Transition>

        <Transition>
            <AddPlaceholder v-if="$store.state.placeholderStore.isShowAddPlaceholder" />
        </Transition>

        <Transition>
            <AddRoomMap v-if="$store.state.roomMap.isShowAddRoomMap" />
        </Transition>

        <Transition>
            <AddVotingModal v-if="$store.state.votingStore.isShowAddVotingModal && votingModule === 1 && $store.state.votingStore.isSessionEnd === false" />
        </Transition>

        <Transition>
            <InteractiveVotingModal v-if="$store.state.votingStore.isShowInteractiveVotingModal && votingModule === 1 && $store.state.votingStore.isSessionEnd === false" />
        </Transition>

        <Transition>
            <InteractiveVotingResults v-if="$store.state.votingStore.isShowInteractiveVotingResultsModal && votingModule === 1" />
        </Transition>

    </section>
</template>
<script charset="utf-8">
    /// Tools
    import SendMeetingRegarding from "./Session/SendMeetingRegarding.vue"
    import PrepareMeetingInvitation from "./Session/PrepareMeetingInvitation.vue"
    import ReportBugModalVue from "./Tools/ReportBugModal.vue"
    import SessionAudioLinkModal from "./Session/SessionAudioVideoLinkModal.vue";
    import ClientInvoiceBuyerModal from "./Settings/ClientInvoiceBuyerModal.vue";

    /// Placeholders
    import AddPlaceholder from "../Panel/Content/Settings/Parts/Modals/AddPlaceholder.vue"

    /// RoomMap
    import AddRoomMap from "../Panel/Content/Settings/Parts/Modals/AddRoomMap.vue"

    /// Voting
    import InteractiveVotingModal from "../Panel/Content/SessionPoints/Modals/InteractiveVotingModal.vue";
    import AddVotingModal from "../Panel/Content/SessionPoints/Modals/AddVotingModal.vue";
    import InteractiveVotingResults from "../Panel/Content/SessionPoints/Modals/InteractiveVotingResults.vue";
    import { encryptStorage } from '../../services/encrypt.service';

    export default {
        name: "ModalsComponents",
        data() {
            return {
                votingModule: encryptStorage.getItem('modules').g,
            };
        },
        components: {
            /// Tools
            ReportBugModalVue,
            SendMeetingRegarding,
            PrepareMeetingInvitation,
            SessionAudioLinkModal,
            AddPlaceholder,
            AddRoomMap,
            AddVotingModal,
            InteractiveVotingModal,
            InteractiveVotingResults,
            ClientInvoiceBuyerModal,
        }
    }
</script>
